module.exports = __webpack_public_path__ + "static/L5Y6s-dfdbe9713bc046c58402282426e9e998.jpg";